// export const API_DOMAIN = 'https://api.viettelmaps.com.vn:8080/gateway/';
// export const FILE_DOMAIN = 'https://files.viettelmaps.com.vn:8080/';
export const API_DOMAIN = 'https://api.viettelmaps.vn/gateway/';
export const FILE_DOMAIN = 'https://files.viettelmaps.vn/';

export const EDIT_FEATURE_MARKER_IMG_URL = FILE_DOMAIN + 'sdk/edit_feature_marker.png';
export const EDIT_FEATURE_MIDDLE_MARKER_IMG_URL = FILE_DOMAIN + 'sdk/edit_feature_middle_marker.png';
